import React, { useRef } from 'react';
import ChatWBG from '../components/ChatWBG';
import { PageRevealStyles, usePageReveal } from '../components/PageReveal';

const ChatPage = ({ isActive }) => {
  const rootRef = useRef(null);

  usePageReveal(rootRef, isActive);

  if (!isActive) return null;

  return (
    <section className="app-page" ref={rootRef}>
      <PageRevealStyles />
      <div className="chart-container" id="chatwbg-card">
        <h2 style={{ marginTop: 0, marginBottom: '1rem' }}>ChatWBG — Vegas Matt’s StatBot</h2>
        <p style={{ marginTop: 0, marginBottom: '1rem' }}>
          Meet <b>ChatWBG</b>: like ChatGPT if it took a wrong turn at the baccarat table and woke up inside a spreadsheet. Ask
          about wins, losses, side bets — it answers using the same public Vegas Matt stats you see on this site. Ask anything
          about the stats — it’s got data, not divination.
        </p>
        <p style={{ fontSize: '.9rem', opacity: 0.8, marginTop: '0.5rem' }}>
          <b>Disclaimer:</b> Responses are generated by AI from publicly available stats. This tool is <b>not</b> affiliated with,
          endorsed by, or officially associated with <b>Vegas Matt</b>, <b>WBG</b>, or their team. It’s for entertainment and
          information only — not gambling advice.
        </p>
        <ChatWBG />
      </div>
    </section>
  );
};

export default ChatPage;
